'use client';
import { File } from '@mybridge/icons';
import { PDFIcon } from '@mybridge/icons/FileIcons';
import { Link, Menu, MenuButton, MenuItem, MenuList } from '@mybridge/ui';
import { Button } from '@mybridge/ui/button';

import { forwardRef } from 'react';
import { ForceSignInWrapper } from 'v4/components/force-sign-in-wrapper';
export const MyProfileMyBioDropdown = forwardRef(
  (
    { jobPreferences, userName, pl = 3, fromPrivate = false, ...props },
    ref
  ) => {
    const resumes = [
      {
        name: jobPreferences?.resume_first_name,
        link: jobPreferences?.resume_first,
      },
      {
        name: jobPreferences?.resume_second_name,
        link: jobPreferences?.resume_second,
      },
    ]?.filter?.((r) => r.link?.length);
    return (
      <>
        {jobPreferences?.file_visibility && resumes?.length ? (
          <Menu>
            <MenuButton
              // w="100%"
              _hover={{
                bg: 'gray.100',
              }}
              {...(resumes?.length > 1
                ? {}
                : {
                    as: Link,
                    target: '_blank',
                    href: resumes?.[0]?.link ?? '#',
                  })}
            >
              {!fromPrivate && (
                <Button pl={pl ?? 3} pr={'107px'} variant="none">
                  <File width="20" height="20" color="#868585" />
                  <span style={{ paddingLeft: '12px', color: '#868585' }}>
                    {`${userName}'s Bio`}
                  </span>
                </Button>
              )}

              {fromPrivate && (
                <Button
                  pl={pl ?? 3}
                  pr={'107px'}
                  color="#5B5B5B"
                  variant="none"
                >
                  {`${userName}'s Bio`}
                </Button>
              )}
            </MenuButton>
            {resumes?.length > 1 ? (
              <ForceSignInWrapper>
              <MenuList>
                {resumes?.map((r, rIndex) => (
                  <MenuItem
                    key={rIndex}
                    as={Link}
                    href={r.link}
                    target="_blank"
                    icon={<PDFIcon width={20} height={20} />}
                  >
                    {r.name?.slice(0,22)+"..."}
                  </MenuItem>
                ))}
              </MenuList>
              </ForceSignInWrapper>
            ) : (
              ''
            )}
          </Menu>
        ) : (
          ''
        )}
      </>
    );
  }
);
